import { useState, useCallback, useEffect } from 'react'

export function useToast() {
  const [toasts, setToasts] = useState([])

  const showToast = useCallback((msg, type = 'info', duration = 3500) => {
    const id = Date.now() + Math.random()
    setToasts(prev => [...prev, { id, msg, type }])
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duration)
  }, [])

  // Expose globally so nested components can call window.__oikeToast(...)
  useEffect(() => { window.__oikeToast = showToast }, [showToast])

  return { toasts, showToast }
}
